import { apiClient, streamText } from './apiClient';
import type { AutoAttachmentDto } from '../types/customerFollowUp/autoAttachment';
import type { RelanceDto, RelanceNoteDto, RelanceRecapDto } from '../types/customerFollowUp/relance';

export const relancesService = {
  listRelances: (search?: string) => {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return apiClient.get<RelanceDto[]>(`/relances${query}`);
  },

  getRelance: (relanceId: string) =>
    apiClient.get<RelanceDto>(`/relances/${relanceId}`),

  getRecap: (relanceId: string) =>
    apiClient.get<RelanceRecapDto>(`/relances/${relanceId}/recap`),

  streamRecommendationField: (
    relanceId: string,
    field: 'title' | 'reason',
    lang: string,
    noAi = false,
    signal?: AbortSignal,
  ): AsyncGenerator<string> =>
    streamText(
      `/relances/${relanceId}/recommendation/stream?field=${field}&language=${lang}${noAi ? '&noAi=true' : ''}`,
      signal,
    ),

  getAutoAttachments: (relanceId: string) =>
    apiClient.get<AutoAttachmentDto[]>(`/relances/${relanceId}/auto-attachments`),

  getAutoAttachmentPreview: (relanceId: string, autoAttachmentId: string) =>
    apiClient.getBlob(`/relances/${relanceId}/auto-attachments/${autoAttachmentId}/preview`),

  addNote: (relanceId: string, note: RelanceNoteDto) =>
    apiClient.post<void>(`/relances/${relanceId}/notes`, note),

  generate: (relanceId: string, noAi = false) =>
    apiClient.post<void>(`/relances/${relanceId}/generate${noAi ? '?noAi=true' : ''}`, undefined),
};
